import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createLx } from '@dativa-lv/lx-ui';
import VueDOMPurifyHTML from 'vue-dompurify-html';

import App from '@/App.vue';
import router from '@/router';
import events from '@/router/events';
import i18n from '@/i18n';
import { APP_CONFIG } from '@/constants';

// Reset & fonts (always required)
import '@dativa-lv/lx-ui/dist/styles/lx-reset.css';
import '@dativa-lv/lx-ui/dist/styles/lx-fonts-carbon.css';

// Theme (product theme + light/dark/contrast utility themes)
import '@dativa-lv/lx-ui/dist/styles/lx-pt-carbon.css';
import '@dativa-lv/lx-ui/dist/styles/lx-ut-carbon-light.css';
import '@dativa-lv/lx-ui/dist/styles/lx-ut-carbon-dark.css';
import '@dativa-lv/lx-ui/dist/styles/lx-ut-carbon-contrast.css';

// Component styles used by this app
import '@dativa-lv/lx-ui/dist/styles/lx-buttons.css';
import '@dativa-lv/lx-ui/dist/styles/lx-inputs.css';
import '@dativa-lv/lx-ui/dist/styles/lx-forms.css';
import '@dativa-lv/lx-ui/dist/styles/lx-forms-grid.css';
import '@dativa-lv/lx-ui/dist/styles/lx-lists.css';
import '@dativa-lv/lx-ui/dist/styles/lx-loaders.css';
import '@dativa-lv/lx-ui/dist/styles/lx-notifications.css';
import '@dativa-lv/lx-ui/dist/styles/lx-modals.css';
import '@dativa-lv/lx-ui/dist/styles/lx-expanders.css';
import '@dativa-lv/lx-ui/dist/styles/lx-animations.css';
import '@dativa-lv/lx-ui/dist/styles/lx-shell-grid.css';
import '@dativa-lv/lx-ui/dist/styles/lx-stack.css';
import '@dativa-lv/lx-ui/dist/styles/lx-cards.css';
import '@dativa-lv/lx-ui/dist/styles/lx-transparency.css';
import '@dativa-lv/lx-ui/dist/styles/lx-toggles.css';
import '@dativa-lv/lx-ui/dist/styles/lx-badges.css';

// Pūrs brand overrides — must load last so they win source order over the theme.
import '@/assets/styles.css';

const app = createApp(App);

app.use(createPinia());
events(router);
app.use(router);
app.use(i18n);
app.use(VueDOMPurifyHTML);

app.use(createLx, {
  systemId: 'purs-upload',
  publicUrl: APP_CONFIG.publicUrl,
  environment: APP_CONFIG.environment,
});

app.mount('#app');
